module.exports = __webpack_public_path__ + "images/career-track-8-dashboard.png";